import { useEffect, useState } from 'react';
import { ResponsiveContainer, LineChart, Line, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';
import { analyticsApi } from '../../api/admin.js';
import { pmApi } from '../../api/pm.js';

export default function QaAnalytics() {
  const [projects, setProjects] = useState([]);
  const [pid, setPid] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => { pmApi.projects().then((d) => { setProjects(d?.items || []); if (d?.items?.[0]) setPid(d.items[0].id); }); }, []);
  useEffect(() => { if (pid) analyticsApi.qa(pid).then(setData); }, [pid]);

  if (!projects.length) return <div className="muted">No projects yet.</div>;

  return (
    <section>
      <header className="page-header">
        <h1>QA Analytics</h1>
        <select value={pid || ''} onChange={(e) => setPid(e.target.value)}>
          {projects.map((p) => <option key={p.id} value={p.id}>{p.key} · {p.name}</option>)}
        </select>
      </header>

      {!data ? <div className="muted">Loading…</div> : (
        <>
          <div className="kpi-row">
            <Kpi label="Defects" value={data.defects.total} sub={`density ${data.defects.density} per SP`} />
            <Kpi label="Defect leakage rate" value={`${data.leakage.rate}%`} sub={`${data.leakage.leaked} of ${data.leakage.total}`} />
          </div>

          <div className="card">
            <h3>Test pass rate (last 12 weeks)</h3>
            <ResponsiveContainer width="100%" height={260}>
              <LineChart data={data.passRate}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="week" />
                <YAxis domain={[0, 100]} />
                <Tooltip />
                <Line type="monotone" dataKey="passRate" stroke="#16a34a" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </div>

          <div className="card">
            <h3>MTTR by severity</h3>
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={data.mttr}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="severity" />
                <YAxis label={{ value: 'hours', angle: -90, position: 'insideLeft' }} />
                <Tooltip />
                <Legend />
                <Bar dataKey="avgHours" fill="#dc2626" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </>
      )}
    </section>
  );
}

function Kpi({ label, value, sub }) {
  return (
    <div className="kpi">
      <div className="kpi-label">{label}</div>
      <div className="kpi-value">{value}</div>
      {sub && <div className="muted small">{sub}</div>}
    </div>
  );
}
